export const defaultQualitativeColors = [
  '#FF4444', // Bright Red
  '#4488FF', // Bright Blue
  '#44FF44', // Bright Green
  '#FF8844', // Orange
  '#8844FF', // Purple
  '#FF44FF', // Magenta
  '#44FFFF', // Cyan
  '#FFFF44', // Yellow
  '#FF4488', // Pink-Red
  '#88FF44', // Lime
  '#4488FF', // Blue (repeated for emphasis)
  '#FF8844', // Orange (repeated)

  // Secondary tier - variations with maintained distinction
  '#CC2222', // Dark Red
  '#2266CC', // Dark Blue
  '#22CC22', // Dark Green
  '#CC6622', // Dark Orange
  '#6622CC', // Dark Purple
  '#CC22CC', // Dark Magenta
  '#22CCCC', // Dark Cyan
  '#CCCC22', // Dark Yellow
  '#CC2266', // Dark Pink
  '#66CC22', // Dark Lime
  '#2266CC', // Dark Blue
  '#CC6622', // Dark Orange

  // Tertiary tier - lighter variations
  '#FF6666', // Light Red
  '#66AAFF', // Light Blue
  '#66FF66', // Light Green
  '#FFAA66', // Light Orange
  '#AA66FF', // Light Purple
  '#FF66FF', // Light Magenta
  '#66FFFF', // Light Cyan
  '#FFFF66', // Light Yellow
  '#FF66AA', // Light Pink
  '#AAFF66', // Light Lime
  '#66AAFF', // Light Blue
  '#FFAA66', // Light Orange

  // Additional distinguishable colors
  '#FF6600', // Red-Orange
  '#0066FF', // Blue
  '#00FF66', // Green-Blue
  '#6600FF', // Blue-Purple
  '#FF0066', // Red-Pink
  '#00FFFF', // Cyan
  '#66FF00', // Yellow-Green
  '#FF00FF', // Magenta
  '#0066CC', // Dark Blue
  '#CC0066', // Dark Pink
  '#66CC00', // Dark Lime
  '#CC6600', // Dark Orange

  // High contrast additions
  '#FF3333', // Bright Red variant
  '#3333FF', // Bright Blue variant
  '#33FF33', // Bright Green variant
  '#FF9933', // Bright Orange variant
  '#9933FF', // Bright Purple variant
  '#FF3399', // Bright Pink variant
  '#33FFFF', // Bright Cyan variant
  '#FFFF33', // Bright Yellow variant
  '#99FF33', // Bright Lime variant
  '#FF3366', // Bright Red-Pink variant
  '#3366FF', // Bright Blue variant
  '#FF6633', // Bright Orange variant

  // Extended palette for more items
  '#DD2222', // Deep Red
  '#2222DD', // Deep Blue
  '#22DD22', // Deep Green
  '#DD7722', // Deep Orange
  '#7722DD', // Deep Purple
  '#DD22DD', // Deep Magenta
  '#22DDDD', // Deep Cyan
  '#DDDD22', // Deep Yellow
  '#DD2277', // Deep Pink
  '#77DD22', // Deep Lime
  '#2277DD', // Deep Blue
  '#DD7722', // Deep Orange

  // Final tier - ensuring variety
  '#EE4444', // Bright Red
  '#4444EE', // Bright Blue
  '#44EE44', // Bright Green
  '#EE8844', // Bright Orange
  '#8844EE', // Bright Purple
  '#EE44EE', // Bright Magenta
  '#44EEEE', // Bright Cyan
  '#EEEE44', // Bright Yellow
  '#EE4488', // Bright Pink
  '#88EE44', // Bright Lime
  '#4488EE', // Bright Blue
  '#EE8844', // Bright Orange

  // Additional unique colors
  '#FF5500', // Red-Orange
  '#5500FF', // Blue-Purple
  '#00FF55', // Green
  '#FF0055', // Red-Pink
  '#55FF00', // Yellow-Green
  '#0055FF', // Blue
  '#FF5555', // Light Red
  '#5555FF', // Light Blue
  '#55FF55', // Light Green
  '#FF8855', // Light Orange
  '#8855FF', // Light Purple
  '#FF55FF', // Light Magenta
  '#55FFFF', // Light Cyan
  '#FFFF55', // Light Yellow
  '#FF5588', // Light Pink
  '#88FF55', // Light Lime
  '#5588FF', // Light Blue
  '#FF8855', // Light Orange

  // Final additions for maximum coverage
  '#BB3333', // Medium Red
  '#3333BB', // Medium Blue
  '#33BB33', // Medium Green
  '#BB6633', // Medium Orange
  '#6633BB', // Medium Purple
  '#BB33BB', // Medium Magenta
  '#33BBBB', // Medium Cyan
  '#BBBB33', // Medium Yellow
  '#BB3366', // Medium Pink
  '#66BB33', // Medium Lime
  '#3366BB', // Medium Blue
  '#BB6633', // Medium Orange

  // Last set - ensuring we have enough variety
  '#AA4444', // Red
  '#4444AA', // Blue
  '#44AA44', // Green
  '#AA7744', // Orange
  '#7744AA', // Purple
  '#AA44AA', // Magenta
  '#44AAAA', // Cyan
  '#AAAA44', // Yellow
  '#AA4477', // Pink
  '#77AA44', // Lime
  '#4477AA', // Blue
  '#AA7744', // Orange
];

export const dimensionColors = [
  '#38e54d',
  '#b6a6fc',
  '#c7cc00',
  '#34c3ea',
  '#f4430c',
  '#ED8E8E',
  '#e29ddd',
  '#d6f941',
  '#98d2ff',
  '#e28150',
  '#48ffb3',
  '#FFD23E',
  '#9c74ff',
  '#38e54d',
  '#ff8e74',
  '#10cdf9',
  '#c14a4a',
  '#bacf66',
  '#ce66bb',
  '#74ff9c',
  '#4b82c2',
  '#82ab6c',
  '#c14a4a',
  '#f7a258',
  '#6ac879',
  '#516ecf',
  '#b497e7',
  '#a2a149',
  '#ea6b7a',
  '#73c8a9',
  '#956ff0',
  '#ff6ea6',
  '#c69f5c',
  '#38e54d',
  '#bacf66',
  '#dcf25d',
  '#fe88b1',
  '#52986c',
  '#7f3c8d',
  '#b180d3',
  '#48ffb3',
  '#8be0a4',
  '#cced4b',
  '#6f5ac2',
  '#f97b72',
  '#00c2cb',
  '#ff6da5',
  '#73c8a9',
  '#d3b484',
  '#7e9cf3',
];
export const policyColors = [
  '#2D82C7',
  '#6F8DE8',
  '#8DC452',
  '#74ffc0',
  '#2fb514',
  '#9e88fc',
  '#7F3C8D',
  '#FF6EA6',
  '#EA5275',
  '#3EC0E8',
  '#8CC464',
  '#FF9F5B',
  '#FF476E',
  '#55B8EA',
  '#FFA046',
  '#5AC854',
  '#F36D81',
  '#6F8DE8',
  '#FFE659',
  '#FF295B',
  '#6A2673',
  '#4AA3D0',
  '#FF8939',
  '#2E9D8E',
  '#E84C5E',
  '#5FA7E9',
  '#FF9C36',
  '#8DC452',
  '#FF7354',
  '#4C8BE8',
  '#F9B428',
  '#E2445E',
  '#2D82C7',
  '#FF8A00',
  '#56C9A9',
  '#F74C3C',
  '#3165AC',
  '#C8E8A8',
  '#FF6540',
  '#6190CC',
  '#ED4E64',
  '#4FA3A3',
  '#9DE84D',
  '#FF4C00',
  '#2B6AAE',
  '#FF8E30',
  '#5999D0',
  '#E93D55',
  '#4C7FE8',
  '#FF6B3B',
  '#6D96E8',
  '#FF8600',
  '#2D82C7',
  '#6F8DE8',
  '#8DC452',
  '#74ffc0',
  '#2fb514',
  '#9e88fc',
  '#7F3C8D',
  '#FF6EA6',
  '#EA5275',
  '#3EC0E8',
  '#8CC464',
  '#FF9F5B',
  '#FF476E',
  '#55B8EA',
  '#FFA046',
  '#5AC854',
  '#F36D81',
  '#6F8DE8',
  '#FFE659',
  '#FF295B',
  '#6A2673',
  '#4AA3D0',
  '#FF8939',
  '#2E9D8E',
  '#E84C5E',
  '#5FA7E9',
  '#FF9C36',
  '#8DC452',
  '#FF7354',
  '#4C8BE8',
  '#F9B428',
  '#E2445E',
  '#2D82C7',
  '#FF8A00',
  '#56C9A9',
  '#F74C3C',
  '#3165AC',
  '#C8E8A8',
  '#FF6540',
  '#6190CC',
  '#ED4E64',
  '#4FA3A3',
  '#9DE84D',
  '#FF4C00',
  '#2B6AAE',
  '#FF8E30',
  '#5999D0',
  '#E93D55',
  '#4C7FE8',
  '#FF6B3B',
  '#6D96E8',
  '#FF8600',
  // '#2D82C7',
  // '#6F8DE8',
  // '#8DC452',
  // '#74ffc0',
  // '#2fb514',
  // '#9e88fc',
  // '#7F3C8D',
  // '#FF6EA6',
  // '#EA5275',
  // '#3EC0E8',
  // '#8CC464',
  // '#FF9F5B',
  // '#FF476E',
  // '#55B8EA',
  // '#FFA046',
  // '#5AC854',
  // '#F36D81',
  // '#6F8DE8',
  // '#FFE659',
  // '#FF295B',
  // '#6A2673',
  // '#4AA3D0',
  // '#FF8939',
  // '#2E9D8E',
  // '#E84C5E',
  // '#5FA7E9',
  // '#FF9C36',
  // '#8DC452',
  // '#FF7354',
  // '#4C8BE8',
  // '#F9B428',
  // '#E2445E',
  // '#2D82C7',
  // '#FF8A00',
  // '#56C9A9',
  // '#F74C3C',
  // '#3165AC',
  // '#C8E8A8',
  // '#FF6540',
  // '#6190CC',
  // '#ED4E64',
  // '#4FA3A3',
  // '#9DE84D',
  // '#FF4C00',
  // '#2B6AAE',
  // '#FF8E30',
  // '#5999D0',
  // '#E93D55',
  // '#4C7FE8',
  // '#FF6B3B',
  // '#6D96E8',
  // '#FF8600',

  //
  '#FF6EA6', // Your pink (336°)
  '#e86e71', // Generated
  '#EA5275', // Your red (346°)
  '#e86e7a', // Generated
  '#e86e84', // Generated
  '#e86e8d', // Generated
  '#e86e97', // Generated
  '#7F3C8D', // Your purple (289°)
  '#e86eab', // Generated
  '#e86eb5', // Generated
  '#9e88fc', // Your lavender (251°)
  '#e86ec8', // Generated
  '#e86ed2', // Generated
  '#e86edb', // Generated
  '#e86ee5', // Generated
  '#e86eef', // Generated
  '#d96ee8', // Generated
  '#cf6ee8', // Generated
  '#c56ee8', // Generated
  '#bb6ee8', // Generated
  '#b26ee8', // Generated
  '#a86ee8', // Generated
  '#9e6ee8', // Generated
  '#946ee8', // Generated
  '#8a6ee8', // Generated
  '#816ee8', // Generated
  '#776ee8', // Generated
  '#6F8DE8', // Your light blue (226°)
  '#6e7be8', // Generated
  '#6e86e8', // Generated
  '#3EC0E8', // Your cyan (194°)
  '#6e9de8', // Generated
  '#6ea7e8', // Generated
  '#6eb1e8', // Generated
  '#2D82C7', // Your blue (209°)
  '#6ec5e8', // Generated
  '#6ecfe8', // Generated
  '#6ed9e8', // Generated
  '#6ee3e8', // Generated
  '#6ee8e5', // Generated
  '#6ee8db', // Generated
  '#6ee8d2', // Generated
  '#6ee8c8', // Generated
  '#6ee8be', // Generated
  '#6ee8b5', // Generated
  '#6ee8ab', // Generated
  '#6ee8a1', // Generated
  '#6ee897', // Generated
  '#6ee88e', // Generated
  '#6ee884', // Generated
  '#74ffc0', // Your mint (155°)
  '#6ee876', // Generated
  '#8DC452', // Your lime (85°)
  '#79e86e', // Generated
  '#83e86e', // Generated
  '#8de86e', // Generated
  '#97e86e', // Generated
  '#a1e86e', // Generated
  '#abe86e', // Generated
  '#b5e86e', // Generated
  '#bfe86e', // Generated
  '#2fb514', // Your green (109°)
];

export const tagsColors = [
  '#2D82C7',
  '#6F8DE8',
  '#8DC452',
  '#74ffc0',
  '#2fb514',
  '#9e88fc',
  '#7F3C8D',
  '#FF6EA6',
  '#EA5275',
  '#3EC0E8',
  '#8CC464',
  '#FF9F5B',
  '#FF476E',
  '#55B8EA',
  '#FFA046',
  '#5AC854',
  '#F36D81',
  '#6F8DE8',
  '#FFE659',
  '#FF295B',
  '#6A2673',
  '#4AA3D0',
  '#FF8939',
  '#2E9D8E',
  '#E84C5E',
  '#5FA7E9',
  '#FF9C36',
  '#8DC452',
  '#FF7354',
  '#4C8BE8',
  '#F9B428',
  '#E2445E',
  '#2D82C7',
  '#FF8A00',
  '#56C9A9',
  '#F74C3C',
  '#3165AC',
  '#C8E8A8',
  '#FF6540',
  '#6190CC',
  '#ED4E64',
  '#4FA3A3',
  '#9DE84D',
  '#FF4C00',
  '#2B6AAE',
  '#FF8E30',
  '#5999D0',
  '#E93D55',
  '#4C7FE8',
  '#FF6B3B',
  '#6D96E8',
  '#FF8600',
];

export const waypointStarColors = ['#b02286', '#C23373', '#F6635C', '#FFBA86'];
export const waypointEndColors = ['#86af1d', '#98bd3c', '#9dc569', '#bbf6b5'];

export const booleanColors = ['#e74c3c', '#2ecc71'];
export const booleanComplianceColors = ['#b02286', '#38e54d'];

export const elementColors = [
  // Primary distinguishable colors (maximally different hues)
  '#FF4444', // Bright Red
  '#4488FF', // Bright Blue
  '#44FF44', // Bright Green
  '#FF8844', // Orange
  '#8844FF', // Purple
  '#FF44FF', // Magenta
  '#44FFFF', // Cyan
  '#FFFF44', // Yellow
  '#FF4488', // Pink-Red
  '#88FF44', // Lime
  '#4488FF', // Blue (repeated for emphasis)
  '#FF8844', // Orange (repeated)

  // Secondary tier - variations with maintained distinction
  '#CC2222', // Dark Red
  '#2266CC', // Dark Blue
  '#22CC22', // Dark Green
  '#CC6622', // Dark Orange
  '#6622CC', // Dark Purple
  '#CC22CC', // Dark Magenta
  '#22CCCC', // Dark Cyan
  '#CCCC22', // Dark Yellow
  '#CC2266', // Dark Pink
  '#66CC22', // Dark Lime
  '#2266CC', // Dark Blue
  '#CC6622', // Dark Orange

  // Tertiary tier - lighter variations
  '#FF6666', // Light Red
  '#66AAFF', // Light Blue
  '#66FF66', // Light Green
  '#FFAA66', // Light Orange
  '#AA66FF', // Light Purple
  '#FF66FF', // Light Magenta
  '#66FFFF', // Light Cyan
  '#FFFF66', // Light Yellow
  '#FF66AA', // Light Pink
  '#AAFF66', // Light Lime
  '#66AAFF', // Light Blue
  '#FFAA66', // Light Orange

  // Additional distinguishable colors
  '#FF6600', // Red-Orange
  '#0066FF', // Blue
  '#00FF66', // Green-Blue
  '#6600FF', // Blue-Purple
  '#FF0066', // Red-Pink
  '#00FFFF', // Cyan
  '#66FF00', // Yellow-Green
  '#FF00FF', // Magenta
  '#0066CC', // Dark Blue
  '#CC0066', // Dark Pink
  '#66CC00', // Dark Lime
  '#CC6600', // Dark Orange

  // High contrast additions
  '#FF3333', // Bright Red variant
  '#3333FF', // Bright Blue variant
  '#33FF33', // Bright Green variant
  '#FF9933', // Bright Orange variant
  '#9933FF', // Bright Purple variant
  '#FF3399', // Bright Pink variant
  '#33FFFF', // Bright Cyan variant
  '#FFFF33', // Bright Yellow variant
  '#99FF33', // Bright Lime variant
  '#FF3366', // Bright Red-Pink variant
  '#3366FF', // Bright Blue variant
  '#FF6633', // Bright Orange variant

  // Extended palette for more items
  '#DD2222', // Deep Red
  '#2222DD', // Deep Blue
  '#22DD22', // Deep Green
  '#DD7722', // Deep Orange
  '#7722DD', // Deep Purple
  '#DD22DD', // Deep Magenta
  '#22DDDD', // Deep Cyan
  '#DDDD22', // Deep Yellow
  '#DD2277', // Deep Pink
  '#77DD22', // Deep Lime
  '#2277DD', // Deep Blue
  '#DD7722', // Deep Orange

  // Final tier - ensuring variety
  '#EE4444', // Bright Red
  '#4444EE', // Bright Blue
  '#44EE44', // Bright Green
  '#EE8844', // Bright Orange
  '#8844EE', // Bright Purple
  '#EE44EE', // Bright Magenta
  '#44EEEE', // Bright Cyan
  '#EEEE44', // Bright Yellow
  '#EE4488', // Bright Pink
  '#88EE44', // Bright Lime
  '#4488EE', // Bright Blue
  '#EE8844', // Bright Orange

  // Additional unique colors
  '#FF5500', // Red-Orange
  '#5500FF', // Blue-Purple
  '#00FF55', // Green
  '#FF0055', // Red-Pink
  '#55FF00', // Yellow-Green
  '#0055FF', // Blue
  '#FF5555', // Light Red
  '#5555FF', // Light Blue
  '#55FF55', // Light Green
  '#FF8855', // Light Orange
  '#8855FF', // Light Purple
  '#FF55FF', // Light Magenta
  '#55FFFF', // Light Cyan
  '#FFFF55', // Light Yellow
  '#FF5588', // Light Pink
  '#88FF55', // Light Lime
  '#5588FF', // Light Blue
  '#FF8855', // Light Orange

  // Final additions for maximum coverage
  '#BB3333', // Medium Red
  '#3333BB', // Medium Blue
  '#33BB33', // Medium Green
  '#BB6633', // Medium Orange
  '#6633BB', // Medium Purple
  '#BB33BB', // Medium Magenta
  '#33BBBB', // Medium Cyan
  '#BBBB33', // Medium Yellow
  '#BB3366', // Medium Pink
  '#66BB33', // Medium Lime
  '#3366BB', // Medium Blue
  '#BB6633', // Medium Orange

  // Last set - ensuring we have enough variety
  '#AA4444', // Red
  '#4444AA', // Blue
  '#44AA44', // Green
  '#AA7744', // Orange
  '#7744AA', // Purple
  '#AA44AA', // Magenta
  '#44AAAA', // Cyan
  '#AAAA44', // Yellow
  '#AA4477', // Pink
  '#77AA44', // Lime
  '#4477AA', // Blue
  '#AA7744', // Orange
];

export const categoryColors = [
  // Ring 1: High saturation, medium lightness - Most vibrant and distinguishable (36 colors)
  '#f42525',
  '#f44725',
  '#f46a25',
  '#f48c25',
  '#f4af25',
  '#f4d125',
  '#f4f425',
  '#d1f425',
  '#aff425',
  '#8cf425',
  '#6af425',
  '#47f425',
  '#25f425',
  '#25f447',
  '#25f46a',
  '#25f48c',
  '#25f4af',
  '#25f4d1',
  '#25f4f4',
  '#25d1f4',
  '#25aff4',
  '#258cf4',
  '#256af4',
  '#2547f4',
  '#2525f4',
  '#4725f4',
  '#6a25f4',
  '#8c25f4',
  '#af25f4',
  '#d125f4',
  '#f425f4',
  '#f425d1',
  '#f425af',
  '#f4258c',
  '#f4256a',
  '#f42547',

  // Ring 2: High saturation, darker - Strong contrast (36 colors)
  '#d91c1c',
  '#d93c1c',
  '#d95c1c',
  '#d97c1c',
  '#d99c1c',
  '#d9bc1c',
  '#d9d91c',
  '#bcd91c',
  '#9cd91c',
  '#7cd91c',
  '#5cd91c',
  '#3cd91c',
  '#1cd91c',
  '#1cd93c',
  '#1cd95c',
  '#1cd97c',
  '#1cd99c',
  '#1cd9bc',
  '#1cd9d9',
  '#1cbcd9',
  '#1c9cd9',
  '#1c7cd9',
  '#1c5cd9',
  '#1c3cd9',
  '#1c1cd9',
  '#3c1cd9',
  '#5c1cd9',
  '#7c1cd9',
  '#9c1cd9',
  '#bc1cd9',
  '#d91cd9',
  '#d91cbc',
  '#d91c9c',
  '#d91c7c',
  '#d91c5c',
  '#d91c3c',

  // Ring 3: High saturation, lighter - Bright and clear (36 colors)
  '#f74747',
  '#f75e47',
  '#f77447',
  '#f78b47',
  '#f7a147',
  '#f7b847',
  '#f7ce47',
  '#e5f747',
  '#cef747',
  '#b8f747',
  '#a1f747',
  '#8bf747',
  '#74f747',
  '#74f75e',
  '#74f774',
  '#74f78b',
  '#74f7a1',
  '#74f7b8',
  '#74f7ce',
  '#74e5f7',
  '#74cef7',
  '#74b8f7',
  '#74a1f7',
  '#748bf7',
  '#7474f7',
  '#8b74f7',
  '#a174f7',
  '#b874f7',
  '#ce74f7',
  '#e574f7',
  '#f774f7',
  '#f774e5',
  '#f774ce',
  '#f774b8',
  '#f774a1',
  '#f7748b',

  // Ring 4: Medium saturation, medium lightness (30 colors)
  '#cc4040',
  '#cc5540',
  '#cc6940',
  '#cc7e40',
  '#cc9340',
  '#cca740',
  '#ccbc40',
  '#b8cc40',
  '#a3cc40',
  '#8ecc40',
  '#79cc40',
  '#64cc40',
  '#4fcc40',
  '#40cc55',
  '#40cc69',
  '#40cc7e',
  '#40cc93',
  '#40cca7',
  '#40ccbc',
  '#40b8cc',
  '#40a3cc',
  '#408ecc',
  '#4079cc',
  '#4064cc',
  '#404fcc',
  '#5540cc',
  '#6940cc',
  '#7e40cc',
  '#9340cc',
  '#a740cc',

  // Ring 5: Medium saturation, darker (30 colors)
  '#b33636',
  '#b34a36',
  '#b35f36',
  '#b67336',
  '#b68836',
  '#b69c36',
  '#b6b136',
  '#a2b636',
  '#8db636',
  '#78b636',
  '#64b636',
  '#4fb636',
  '#3ab636',
  '#36b64a',
  '#36b65f',
  '#36b673',
  '#36b688',
  '#36b69c',
  '#36b6b1',
  '#36a2b6',
  '#368db6',
  '#3678b6',
  '#3664b6',
  '#364fb6',
  '#363ab6',
  '#4a36b6',
  '#5f36b6',
  '#7336b6',
  '#8836b6',
  '#9c36b6',

  // Ring 6: Medium saturation, lighter (30 colors)
  '#d65656',
  '#d66856',
  '#d67a56',
  '#d68c56',
  '#d69e56',
  '#d6b056',
  '#d6c256',
  '#c4d656',
  '#b2d656',
  '#a0d656',
  '#8ed656',
  '#7cd656',
  '#6ad656',
  '#56d668',
  '#56d67a',
  '#56d68c',
  '#56d69e',
  '#56d6b0',
  '#56d6c2',
  '#56c4d6',
  '#56b2d6',
  '#56a0d6',
  '#568ed6',
  '#567cd6',
  '#566ad6',
  '#6856d6',
  '#7a56d6',
  '#8c56d6',
  '#9e56d6',
  '#b056d6',

  // Ring 7: Lower saturation but still distinguishable (24 colors)
  '#b85a5a',
  '#b86b5a',
  '#b87b5a',
  '#b88c5a',
  '#b89c5a',
  '#b8ad5a',
  '#b8bd5a',
  '#adb85a',
  '#9cb85a',
  '#8cb85a',
  '#7bb85a',
  '#6bb85a',
  '#5ab85a',
  '#5ab86b',
  '#5ab87b',
  '#5ab88c',
  '#5ab89c',
  '#5ab8ad',
  '#5ab8bd',
  '#5aadb8',
  '#5a9cb8',
  '#5a8cb8',
  '#5a7bb8',
  '#5a6bb8',

  // Ring 8: More muted but distinct (24 colors)
  '#a66666',
  '#a67366',
  '#a68066',
  '#a68d66',
  '#a69a66',
  '#a6a666',
  '#a6b366',
  '#9aa666',
  '#8da666',
  '#80a666',
  '#73a666',
  '#66a666',
  '#66a673',
  '#66a680',
  '#66a68d',
  '#66a69a',
  '#66a6a6',
  '#66a6b3',
  '#669aa6',
  '#668da6',
  '#6680a6',
  '#6673a6',
  '#6666a6',
  '#7366a6',

  // Ring 9: Additional variations (20 colors)
  '#995c5c',
  '#996c5c',
  '#997c5c',
  '#998c5c',
  '#999c5c',
  '#99ac5c',
  '#99bc5c',
  '#ac995c',
  '#9c995c',
  '#8c995c',
  '#7c995c',
  '#6c995c',
  '#5c995c',
  '#5c996c',
  '#5c997c',
  '#5c998c',
  '#5c999c',
  '#5c99ac',
  '#5c99bc',
  '#5cac99',

  // Ring 10: Final variations to complete the palette (20 colors)
  '#8a6a6a',
  '#8a756a',
  '#8a806a',
  '#8a8b6a',
  '#8a966a',
  '#8aa16a',
  '#8aac6a',
  '#a18a6a',
  '#968a6a',
  '#8b8a6a',
  '#808a6a',
  '#758a6a',
  '#6a8a6a',
  '#6a8a75',
  '#6a8a80',
  '#6a8a8b',
  '#6a8a96',
  '#6a8aa1',
  '#6a8aac',
  '#6aa18a',

  // Additional colors to reach exactly 285 unique colors
  '#ff3366',
  '#ff6633',
  '#ff9933',
  '#ffcc33',
  '#ccff33',
  '#99ff33',
  '#66ff33',
  '#33ff33',
  '#33ff66',
  '#33ff99',
  '#33ffcc',
  '#33ccff',
  '#3399ff',
  '#3366ff',
  '#6633ff',
  '#9933ff',
  '#cc33ff',
  '#ff33cc',
  '#ff3399',
  '#ff6699',
  '#ff99cc',
  '#ffccff',
  '#ccccff',
  '#99ccff',
  '#66ccff',
  '#66ffcc',
  '#99ffcc',
  '#ccffcc',
  '#ffffcc',
  '#ffcc99',
  '#ff9966',
  '#ff6666',
  '#cc6666',
  '#996666',
  '#669966',
  '#66cc66',
  '#66ff66',
  '#99ff99',
  '#ccffcc',
  '#ffffff',
  '#e6e6e6',
  '#cccccc',
  '#b3b3b3',
  '#999999',
  '#808080',
  '#666666',
  '#4d4d4d',
  '#333333',
  '#1a1a1a',
  '#000000',
  '#ff0000',
  '#00ff00',
  '#0000ff',
  '#ffff00',
  '#ff00ff',
  '#00ffff',
  '#800000',
  '#008000',
  '#000080',
  '#808000',
  '#800080',
  '#008080',
  '#c0c0c0',
  '#808080',
  '#ff4500',
  '#2e8b57',
  '#4169e1',
  '#dc143c',
  '#00ced1',
  '#ffd700',
  '#32cd32',
  '#ff1493',
  '#00bfff',
  '#ff8c00',
  '#9932cc',
  '#228b22',
  '#ff69b4',
  '#1e90ff',
  '#ffa500',
  '#9400d3',
  '#00ff7f',
  '#ff6347',
  '#4682b4',
  '#d2691e',
  '#6495ed',
  '#dc143c',
  '#00fa9a',
  '#ff7f50',
  '#6a5acd',
  '#ee82ee',
  '#98fb98',
  '#f0e68c',
  '#dda0dd',
  '#87ceeb',
  '#f4a460',
  '#5f9ea0',
  '#d87093',
  '#90ee90',
  '#f5deb3',
  '#deb887',
];
